module.exports = __webpack_public_path__ + "img/lbyc12.e4e8c36a.png";